/**
 * @hidden
 */
var PreventableEvent = function () {
  function PreventableEvent() {
    this.prevented = false;
  } // tslint:disable:max-line-length

  /**
   * Prevents the default action for a specified event.
   * In this way, the source component suppresses the built-in behavior that follows the event.
   */


  PreventableEvent.prototype.preventDefault = function () {
    this.prevented = true;
  };
  /**
   * Returns `true` if the event was prevented by any of its subscribers.
   *
   * @returns - Returns `true` if the default action was prevented.
   * Otherwise, returns `false`.
   */


  PreventableEvent.prototype.isDefaultPrevented = function () {
    return this.prevented;
  };

  return PreventableEvent;
}();

export { PreventableEvent }; // tslint:enable:max-line-length